import React from "react";
import { TilesWrapper } from "./style";
import PropTypes from "prop-types";
import Slider from "react-slick";
import { Helmet } from "react-helmet";

const Tiles = (props) => {
	const { heading, tilesArray } = props;

	const settings = {
		responsive: [
			{
				breakpoint: 760,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
				},
			},
		],
	};

	return (
		<TilesWrapper>
			<Helmet>
				<link
					rel="stylesheet"
					type="text/css"
					charset="UTF-8"
					href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
				/>
				<link
					rel="stylesheet"
					type="text/css"
					href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
				/>
			</Helmet>
			<div className="heading">{heading}</div>
			<div className="container">
				{tilesArray.map((point, index) => {
					return (
						<div key={index} className="item">
							{point.bulletPoint}
						</div>
					);
				})}
			</div>
			<Slider {...settings}>
				{tilesArray.map((point, index) => {
					return (
						<div key={index} className="mobileContainer">
							<div className="item">{point.bulletPoint}</div>
						</div>
					);
				})}
			</Slider>
		</TilesWrapper>
	);
};

Tiles.propTypes = {
	heading: PropTypes.string,
	tilesArray: PropTypes.array,
};

Tiles.defaultProps = {
	heading: "",
	tilesArray: [],
};

export default Tiles;
